import React, { useEffect, useState } from 'react';
import './time-passing.css';
import { goToScreen } from '../../actions/router';
import { END_OF_DAY_SCREEN } from '../../constants/routes';
import { connect } from 'react-redux';
import { Icon } from '../../components/icon';
import { ReactComponent as Pattern } from '../../assets/images/vector-pattern.svg';
import classNames from 'classnames';

const TimePassingScreen = props => {
    const { timePassed } = props;

    const [enterAnimation, setEnterAnimation] = useState(false);
    const [exitAnimation, setExitAnimation] = useState(false);
    const [animationFinished, setAnimationFinished] = useState(false);

    useEffect(() => {
        if (animationFinished === true) {
            timePassed();
        }
    }, [animationFinished, timePassed]);

    useEffect(() => {
        const enterTimeout = setTimeout(() => {
            setEnterAnimation(true);
        }, 500);
        const exitTimeout = setTimeout(() => {
            setExitAnimation(true);
        }, 3500);
        const passTimeTimeout = setTimeout(() => {
            setEnterAnimation(false);
            setAnimationFinished(true);
        }, 5000);
        return () => {
            clearTimeout(enterTimeout);
            clearTimeout(exitTimeout);
            clearTimeout(passTimeTimeout);
        };
    }, []);

    const timePassingScreenClasses = classNames({
        'time-passing-screen': true,
        'time-passing-screen--entry': enterAnimation,
    });

    const clockClasses = classNames({
        'time-passing-screen__clock': true,
        'time-passing-screen__clock--entry': enterAnimation || !exitAnimation,
        'time-passing-screen__clock--exit': exitAnimation,
    });

    return (
        <div
            className={timePassingScreenClasses}
            role="alert"
            aria-label="time passing"
        >
            <div className="time-passing-screen__pattern">
                <Pattern height="100%" width="100%" />
            </div>
            <div className={clockClasses}>
                <Icon iconName="clock" size="x-large" altText="" />
                <div className="time-passing-screen__clock-hands">
                    <span className="time-passing-screen__clock-center" />
                    <span className="time-passing-screen__clock-hand time-passing-screen__clock-hour-hand" />
                    <span className="time-passing-screen__clock-hand time-passing-screen__clock-minute-hand" />
                </div>
            </div>
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        timePassed: () => {
            dispatch(goToScreen(END_OF_DAY_SCREEN));
        },
    };
};

const connected = connect(null, mapDispatchToProps)(TimePassingScreen);
export { connected as TimePassingScreen };
